module.exports = {
  Mode: {
    NESTED: 'nested',
    FLOAT: 'float',
    DEFAULT: 'nested'
  }
};
